import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../../add-form-proto";
import CustomFieldLeftPanel from "../../../common/panel/form-left-panel";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";
import CustomFieldFormula from "../../../common/form-formula";
import Formula from "src/core/gd/utils/formula";
import CustomFieldSymbol from "../../../common/form-symbol";
import CustomFieldDecimalPlaces from "../../../common/form-decimal-places";
import CustomFieldPreview from "../../../common/form-preview";
import CustomFieldFormat from "../../../common/form-format";

export default class FormCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.FORMULA;

        this.initFormData.formatType = 'number';
        this.initFormData.decimalPlaces = null;
        this.initFormData.symbol = 'us_dollar';
        this.initFormData.formula = null;

        if (this.props.customField) {
            this.initFormData.formatType = _.get(this.props.customField.params,'formatType', 'number');
            this.initFormData.decimalPlaces = _.get(this.props.customField.params,'decimalPlaces',null);
            this.initFormData.symbol = _.get(this.props.customField.params,'symbol','us_dollar');
            this.initFormData.formula = _.get(this.props.customField.params,'formula', null);
        }

        this.formStructure.fields.formatType = {
            type: 'select',
            isRequired: false,
            label: 'Format type',
            onUserChange: () => this.forceUpdate()
        };

        this.formStructure.fields.decimalPlaces = {
            type: 'select',
            isRequired: false,
            label: 'Decimal places',
            onUserChange: () => this.forceUpdate()
        };

        this.formStructure.fields.symbol = {
            type: 'select',
            isRequired: false,
            label: 'Symbol',
            onUserChange: () => this.forceUpdate()
        };

        this.formStructure.fields.formula = { type: 'input', label: 'Formula',
            validator: (val) => {
                let res = true;
                if (!val || !val.trim()) res = 'Formula is required';
                else {
                    const {isValid, error} = Formula.isFormulaValid(val);
                    if (!isValid) {
                        switch (error) {
                            case 'invalid_field':               res = 'Formula contains incorrect field'; break;
                            case 'invalid_characters':          res = 'Formula contains characters that are not allowed'; break;
                        }
                    }
                }
                return res;
            }
        };

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.FORMULA;

        result.params = {
            formatType: result.formatType,
            decimalPlaces: result.decimalPlaces,
            symbol: result.symbol,
            formula: result.formula,
            scope: result.scope
        };

        this.props.onSubmit(result);
    }

    getCurrencyMark() {
        const currencyId = this.form.getValue('symbol');
        let currencyMark = '';

        for (let availableCurrId in gd.const.currency) {
            if (availableCurrId === currencyId)  {
                currencyMark = gd.const.currency[availableCurrId].symbol;
                break;
            }
        }

        return currencyMark;
    }

    render() {
        const formatType = this.form.getValue('formatType')

        const previewValue = 1500.45
        let preview
        switch (formatType) {
            case 'currency':
                preview = (
                    <div className="txt m-l-15">
                        {this.getCurrencyMark()} {gd.utils.Format.currency(previewValue, this.form.getValue('decimalPlaces'), true)}
                    </div>
                )
                break

            case 'number':
                preview = (
                    <div className="txt m-l-15">
                        {gd.utils.Format.number(previewValue, this.form.getValue('decimalPlaces'), false)}
                    </div>
                )
                break

            case 'percentage':
                preview = (
                    <div className="txt m-l-15">
                        {gd.utils.Format.number(previewValue, this.form.getValue('decimalPlaces'), false)} %
                    </div>
                )
                break
        }

        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        {preview}
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldFormat form={this.form}/>
                    {formatType === 'currency' && <CustomFieldSymbol form={this.form}/>}
                    <CustomFieldDecimalPlaces form={this.form}/>
                    <CustomFieldFormula form={this.form}/>
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}
